export const VIDEO_PER_PAGE_MAX = 5;
